import React from 'react'
import { Box, Container, Typography } from '@mui/material'

const PrivacyPage: React.FC = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, color: '#8B4513' }}>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#666', mb: 4 }}>
          Coming Soon
        </Typography>
        <Typography variant="body1" sx={{ color: '#444' }}>
          Our Privacy Policy is currently being drafted. Please check back soon for details on
          how CigarTrack collects, uses, and protects your personal information.
        </Typography>
      </Container>
    </Box>
  )
}

export default PrivacyPage
